import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/glamping-for-large-groups";
const TITLE = "Glamping for Large Groups — Private Buyouts in Arizona | Backland";
const DESC =
  "Host your large group at Backland: full-property glamping buyouts on 160 private acres near the Grand Canyon, with luxury tented suites, on-site dining, and event support.";
const OG_IMAGE =
  "/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg";

export const Route = createFileRoute("/glamping-for-large-groups")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          name: "Backland — Large Group Glamping & Buyouts",
          url: URL,
          description: DESC,
        }),
      },
    ],
  }),
  component: LargeGroupsRoute,
});

function LargeGroupsRoute() {
  return <StoryExperience initialCategorySlug="groups" />;
}
